import * as React from "react";

/* Full-bleed cinematic photo strip with an overlaid line. */
function Band({ image, alt, kicker, text }) {
  return (
    <div className="trps-band">
      <img src={image} alt={alt} loading="lazy" />
      <div className="trps-band__overlay">
        <div>
          {kicker && (
            <p className="trps-eyebrow" style={{ color: "rgba(255,255,255,.7)", marginBottom: 14 }}>
              {kicker}
            </p>
          )}
          <p className="trps-band__text">{text}</p>
        </div>
      </div>
    </div>
  );
}

export default Band;
